import { useMemo } from 'react';
// import { getValidDate } from '@gp/utils/common';

interface Props {
  sourceData: orgHeadcountsDataTypes;
}

const useTableList = (props: Props) => {
  const { sourceData } = props;

  const resultList = useMemo(() => {
    const targetMetrics = sourceData?.metrics || [],
      targetData = sourceData?.dataList || [];
    if (!Array.isArray(targetData) || !targetData?.length) return;

    return {
      records: targetData?.map((t: { [key: string]: string }, i: number) => ({
        uniqueId: String(i),
        ...t,
      })),
      colList: targetMetrics,
    };
  }, [sourceData]);

  return {
    records: resultList?.records || [],
    colList: resultList?.colList || [],
  };
};

useTableList.defaultProps = {
  sourceData: null,
};

export default useTableList;
